var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data)?_c('div',[_vm._t("default")],2):(_vm.loading)?_c('PageLoader'):_c('PageError',{attrs:{"title":_vm.errorTitle,"subtitle":_vm.error,"button":_vm.errorButton,"to":_vm.errorTo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }